// extracted by mini-css-extract-plugin
module.exports = {"suggestions":"SearchBar-styles-suggestions-d0fd164b"};